import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/699ad1e4f782d5001402abd4/pc_cargo_website/src/app/bulk-orders/components/BulkOrdersContent.tsx");
